import React, { Component } from 'react';

export default class Resumo extends Component {
  parte1 = () => {
    return (
      <div>
        <p>
          Conheça a estrutura do sistema financeiro, quem são seus integrantes e quais são as
          principais funções por eles desempenhadas.{' '}
        </p>
        <p>
          Nesse material você vai aprender: o que é intermediação financeira, quem são os
          reguladores do mercado financeiro, o papel da ANBIMA, o que é Sistema de Pagamentos
          Brasileiro e as funções dos sistemas de liquidação e custódia.{' '}
        </p>
      </div>
    );
  };
  parte2 = () => {
    return (
      <div>
        <p>
          Conheça as principais medidas regulatórias que garantem a ética nas atividades de
          intermediação financeira.
        </p>
        <p>
          Neste material você vai conhecer o modelo de autorregulação da ANBIMA, entender o conceito
          de lavagem de dinheiro e como preveni-la, aprender o que é venda casada, e o objetivo da
          adequação dos produtos, serviços e operações ao perfil do cliente, o famoso suitability.
        </p>
      </div>
    );
  };
  parte3 = () => {
    return (
      <div>
        <p>
          Entenda os principais conceitos de economia e finanças, como índices de mercado e sua
          relação com o comportamento dos preços dos ativos.
        </p>
        <p>
          Nessa terceira parte dos estudos para a CPA-10, você vai entender o que é PIB, IPCA,
          IGP-M, Selic, câmbio, DI, TR, inflação, deflação, volatilidade, regimes de capitalização,
          Copom e diversos outros conceitos que fazem parte de nosso mercado financeiro.
        </p>
      </div>
    );
  };
  parte4 = () => {
    return (
      <div>
        <p>
          Entenda o papel dos agentes econômicos e as características dos ativos existentes no
          mercado financeiro nacional.
        </p>
        <p>
          Nesse material, você vai aprender o que é risco, rentabilidade e liquidez dos ativos, além
          de entender a classificação de perfil dos investidores, seus objetivos e sua capacidade em
          assumir riscos.
        </p>
        <p>
          Para encerrar, você vai entender o que é IPS, diversificação de carteiras e planejamento
          financeiro.
        </p>
      </div>
    );
  };
  parte5 = () => {
    return (
      <div>
        <p>Os fundos de investimento são um dos principais produtos de nosso mercado financeiro.</p>
        <p>
          Nessa quinta etapa de estudos da CPA-10, você vai aprender o que são fundos de
          investimento e suas características, quem são os profissionais que atuam neles e as suas
          funções, os tipos de fundo existentes no mercado brasileiro, as regras que regem o
          produto, a forma como são negociados e a sua operacionalização.
        </p>
      </div>
    );
  };
  parte6 = () => {
    return (
      <div>
        <p>
          Na sexta parte dos estudos para a CPA-10, você vai saber o que são instrumentos de renda
          variável e de renda fixa, aprendendo a diferenciá-los.
        </p>
        <p>
          Em seguida, vai poder se aprofundar em todos os conceitos que permeiam os dois mundos,
          passando por seus canais de distribuição e pelas características de cada um dos títulos
          disponíveis em nosso mercado, como Tesouro Nacional, ações, poupança e debêntures.
        </p>
      </div>
    );
  };
  parte7 = () => {
    return (
      <div>
        <p>
          Na última parte do material de estudos da CPA-10, você vai entender como funciona o nosso
          sistema de previdência complementar aberta.
        </p>
        <p>
          Você vai começar seus estudos entendendo os conceitos básicos do assunto e descobrindo
          como funciona a previdência social no Brasil. Ao fim da leitura, você saberá os benefícios
          de complementar a aposentadoria oficial e avaliar planos em função dos objetivos do
          cliente.
        </p>
      </div>
    );
  };

  resumo = () => {
    switch (this.props.path) {
      case '/sistema-financeiro':
        return <this.parte1 />;

      case '/analise-do-perfil-investidor':
        return <this.parte2 />;

      case '/conceitos-basicos-economia-financas':
        return <this.parte3 />;

      case '/principios-de-investimento':
        return <this.parte4 />;

      case '/fundos-de-investimento':
        return <this.parte5 />;

      case '/renda-variavel-fixa':
        return <this.parte6 />;

      case '/previdencia':
        return <this.parte7 />;
      default:
    }
  };
  render() {
    return (
      <section>
        <this.resumo />
        <ul className="social-media">
          <li>
            <a
              href="http://www.facebook.com/AnbimaBR"
              className="fa fa-facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              &nbsp;
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/anbima---brazilian-financial-and-capital-markets-association"
              className="fa fa-linkedin"
              target="_blank"
              rel="noopener noreferrer"
            >
              &nbsp;
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/Anbima_BR"
              className="fa fa-twitter"
              target="_blank"
              rel="noopener noreferrer"
            >
              &nbsp;
            </a>
          </li>
          <li>
            <a
              href="http://www.youtube.com/user/AnbimaBR"
              className="fa fa-youtube"
              target="_blank"
              rel="noopener noreferrer"
            >
              &nbsp;
            </a>
          </li>
        </ul>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Resumo.js